module.exports = __webpack_public_path__ + "static/2-17ba8f4b4c36d5e9bc0874ae40437d87.jpg";